import React from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";

const Button = ({
  disabled,
  onClick,
  fontSize = "1rem",
  width = "100%",
  startIcon,
  endIcon,
  label,
  backgroundColor = Colors.aqua,
  variant = "outlined",
  outlineColor,
  fontColor = Colors.white,
  padding = "0.75rem 1.25rem",
  borderRadius = "0.5rem",
  hoverColor,
  hoverFontColor,
}) => {
  return (
    <StyledButton
      fontSize={fontSize}
      type="button"
      disabled={disabled}
      onClick={onClick}
      width={width}
      backgroundColor={backgroundColor}
      variant={variant}
      outlineColor={outlineColor}
      fontColor={fontColor}
      padding={padding}
      borderRadius={borderRadius}
      hoverColor={hoverColor}
      hoverFontColor={hoverFontColor}
    >
      {startIcon}
      {label}
      {endIcon}
    </StyledButton>
  );
};
const StyledButton = styled.button`
  transition: background-color 0.5s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: ${(props) => props.width};
  border-radius: ${(props) => props.borderRadius};
  background: ${(props) =>
    props.variant === "outlined" ? Colors.transperant : props.backgroundColor};

  border: ${(props) =>
    props.variant === "outlined"
      ? props.outlineColor
        ? `0.2rem solid ${props.outlineColor}`
        : `0.2rem solid ${Colors.aqua}`
      : "transparent"};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  color: ${(props) =>
    props.variant === "outlined" ? Colors.aqua : props.fontColor};
  font-family: Poppins;
  font-size: ${(props) => props.fontSize};
  padding: ${(props) => props.padding};
  cursor: pointer;
  &:disabled {
    opacity: 0.4;
  }
  &:hover {
    background: ${(props) => props.hoverColor};
    color: ${(props) => props.hoverFontColor};
  }
`;
const IconContainer = styled.span`
  margin-left: -1.25rem;
  padding: 0rem 0.94rem;
`;

export default Button;
